(function () {
  const COOKIE_NAME = 'discount_code';
  const STORAGE_KEY = 'shopify:discount_code';
  const TARGET_SELECTOR = '#athlete-discount';

  /* Attend que l’élément existe dans le DOM */
  function waitForElement(selector, callback, timeout = 5000) {
    const start = Date.now();

    function check() {
      const el = document.querySelector(selector);
      if (el) {
        callback(el);
      } else if (Date.now() - start < timeout) {
        requestAnimationFrame(check);
      }
    }
    check();
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function getDiscountCode() {
    try {
      const urlCode = new URLSearchParams(window.location.search).get('discount');
      return urlCode || getCookie(COOKIE_NAME) || localStorage.getItem(STORAGE_KEY);
    } catch {
      return getCookie(COOKIE_NAME) || localStorage.getItem(STORAGE_KEY);
    }
  }

  function setVisibility(pEl, visible) {
    if (!pEl) return;
    // display none pour que le <p> "ne doit pas apparaitre"
    pEl.style.display = visible ? '' : 'none';
    if (visible) pEl.removeAttribute('aria-hidden');
    else pEl.setAttribute('aria-hidden', 'true');
  }

  function getStaticText(code) {
    const lang = (document.documentElement.lang || '').toLowerCase();
    const upper = (code || '').toUpperCase();

    if (lang.startsWith('fr')) return `-${upper}% APPLIQUÉ AU CHECKOUT`;
    return `-${upper}% APPLIED AT CHECKOUT`;
  }

  function render(code, pEl) {
    if (!pEl) return;

    // Si pas de code => on masque tout le bloc
    if (!code) {
      setVisibility(pEl, false);
      return;
    }

    // Sinon on affiche
    setVisibility(pEl, true);

    const upper = String(code).trim().toUpperCase();

    // Si ton HTML contient un <span>, on remplace juste le span (= discount name)
    const span = pEl.querySelector('span');
    if (span) span.textContent = upper;

    // Optionnel : si tu veux aussi mettre à jour le texte autour du span sans casser la structure,
    // on reconstruit le <p> en gardant un span au milieu.
    // Exemple attendu: "-15% WITH <span>ATHLETE</span> APPLIED AT CHECKOUT"
    const lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.startsWith('fr')) {
      pEl.innerHTML = `-15% AVEC <span>${upper}</span> APPLIQUÉ AU CHECKOUT`;
    } else {
      pEl.innerHTML = `-15% WITH <span>${upper}</span> APPLIED AT CHECKOUT`;
    }
  }

  function init() {
    waitForElement(TARGET_SELECTOR, (pEl) => {
      // On masque d’abord par défaut (évite le flash si le code n’existe pas)
      setVisibility(pEl, false);

      const code = getDiscountCode();

      // Si pas de code => on laisse caché et on stop
      if (!code) return;

      // Si code => on persiste et on affiche
      localStorage.setItem(STORAGE_KEY, code);
      render(code, pEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();